<template>
	<div class="col-12 col-lg-8">
		<div class="col-12 d-flex flex-column align-items-center">
			<img src="/svg/success_page_form.svg" alt="success_page_form">
			<span class="title title-lg text-center">
				Рады приветствовать вас в Московской школе управления СКОЛКОВО!
			</span>
			<span class="text-center mb-4">
				В ближайшее время с вами свяжется менеджер программы
			</span>
			<div v-if="!isOrderFree" class="col-12 d-flex justify-content-center align-items-center">
				<template v-if="isNotPaidOrder">
					<img src="/svg/success_page_form__warning.svg">
					<span class="ml-3">
						Требуется оплата участия, <br>
						<a :href="`/order/${orderHash}`" target="_blank">Перейти в личный кабинет для оплаты</a>
					</span>
				</template>
				<template v-if="isPaidOrder">
					<img src="/svg/success_page_form__check.svg">
					<span class="ml-3">
						Участие в программе оплачено
					</span>
				</template>
			</div>
		</div>
		<div v-if="order" class="list-titles my-4">
			<div
				v-if="order.data.products && order.data.products.length > 0 && !isOrderFree"
				class="d-flex flex-lg-row flex-column text-center align-items-lg-end align-items-center"
			>
				<div>
					{{ order.data.products[0].title }}
				</div>
				<div class="border-dote d-none d-lg-flex" />
				<div class="title mb-0">
					{{ createMaskAmount(order.data.amount) }} ₽
				</div>
			</div>
			<div v-if="url" class="d-flex align-items-end mt-3">
				<span>Счет на оплату</span>
				<div class="border-dote" />
				<span>
					<b-button
						variant="outline-primary"
						@click="downloadPdf(url, 'Счет на оплату')"
					>
						Скачать
					</b-button>
				</span>
			</div>
		</div>
		<div class="col-10 d-flex flex-column align-items-center ml-auto mr-auto">
			<div class="row">
				<a
					v-if="!isOrderFree"
					type="button"
					target="_blank"
					class="col-12 col-lg success_page__card new-student justify-content-center mr-0 mr-lg-4"
					@click="newStudentHandler"
				>
					<span class="description strong text-center mt-2">
						Зарегистрировать других студентов
					</span>
				</a>
				<a
					type="button"
					target="_blank"
					:href="urlAgreement"
					class="col-12 col-lg success_page__card mt-2 mt-lg-0"
				>
					<img src="/svg/form_offert.svg">
					<span class="description strong text-center mt-2">
						Скачайте и ознакомьтесь с договором оферты
					</span>
				</a>
				<a
					v-if="$auth.user && isShowDocumentsCheck"
					class="col-12 col-lg success_page__card ml-0 ml-lg-4 mt-2 mt-lg-0"
					href="/user/profile/?item=Documents"
				>
					<img src="/svg/form_documents.svg">
					<span class="description strong text-center mt-2">
						Проверьте загруженные документы в личном кабинете
					</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
	FORMULATE_ORDER_STATUSES,
	FORM_PAYER_TYPE,
	ORDER_TYPES,
} from '~/utils/dictionaries';

import paymentFormMixin from '~/mixins/paymentFormMixin';
import panel from '~/mixins/panel';
import { createMaskAmount } from '~/utils/intl-converter';
import downloadPdf from '~/utils/pdf';

export default {
	name: 'SuccessStep',
	mixins: [paymentFormMixin, panel],
	inject: ['order'],
	data() {
		return {
			url: '',
		};
	},
	computed: {
		...mapState('scenarios/paymentForm', ['orderHash', 'personData']),
		urlAgreement() {
			return this.order?.unauthAgreements[0];
		},
		isPaidOrder() {
			return this.order.data.status === FORMULATE_ORDER_STATUSES.PAID;
		},
		isNotPaidOrder() {
			return this.order.data.status === FORMULATE_ORDER_STATUSES.NOT_PAID;
		},
		isShowDocumentsCheck() {
			const { payer_type: payerType, is_representative: isRepresentative } = this.personData;
			return !isRepresentative && payerType !== FORM_PAYER_TYPE.URIDIC;
		},
		isOrderFree() {
			return this.order.data.type === ORDER_TYPES.FREE;
		},
	},
	async created() {
		this.$emit('updateOrder');
		await this.$api.getOrderCheckoutData(this.orderHash).then((res) => {
			this.url = res.data.url;
		});
	},
	methods: {
		createMaskAmount,
		downloadPdf,
		...mapActions('scenarios/paymentForm', ['setCurrentStep', 'getPersonData']),
		async newStudentHandler() {
			await this.$router.push(this.$route.path);
			await this.setCurrentStep(this.STEPS.RESET);
			await this.getPersonData(this.block.scenario_id);
		},
	},
};

</script>

<style scoped lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.border-dote {
	flex: 1 0;
	border-bottom: 2px dotted #000;
	height: 1em;
	margin: 0 .4em;
	margin-bottom: 6px;
}

.list-titles {
	font-size: 1.2rem;
}

.success_page__card {
	cursor: pointer;
	width: 19rem;
	padding: 1.5rem 2rem;
	border-radius: 1rem;
	background: #F4F4F4;

	display: flex;
	flex-direction: column;
	align-items: center;
	color: black;

	&.new-student {
		background: #E9F0FD;
	}

	&:hover {
		background: #eeeeee;
	}
}
</style>
